export default __webpack_public_path__ + "images/636c4d68005991ddf116fba9caf5b17f.png";